/**
 * Filename: 接口请求
 * Created Date: 2022/4/8
 * Author: zz
 *
 * Copyright (c) 2021 Your Company
 */

import axios from './index';
import qs from 'qs';
import CONFIG from '@/config';
let baseURL = CONFIG.BASE_URL;

let headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
};

export default {
    // 检查文件是否存在
    getDownloadFile(params) {
        return axios(baseURL + '/common/check', {
            method: 'get',
            params,
            handleTipsBySelf: true,
        });
    },
    loginEmail(data) {
        //邮箱登录
        return axios(baseURL + '/login_email', {
            method: 'post',
            data: qs.stringify(data),
            headers,
        });
    },
    loginPhone(data) {
        //手机号登录
        return axios(baseURL + '/login_phone', {
            method: 'post',
            data: qs.stringify(data),
            headers,
        });
    },
    getEmailReset(data) {
        return axios(baseURL + '/email/reset_password', {
            //发送重置密码邮件
            method: 'get',
            data,
        });
    },
    sendMsg(data) {
        //发送登录短信
        return axios(baseURL + '/sms/login', {
            method: 'get',
            data,
        });
    },
    resetPassowrd(data) {
        // 密码重置
        return axios(baseURL + '/reset_password', {
            method: 'post',
            data: qs.stringify(data),
            headers,
        });
    },
    // 手机号密码登录
    loginPhonePassword(data) {
        return axios(baseURL + '/login_identifier', {
            method: 'post',
            data: qs.stringify(data),
            headers,
        });
    },
    // 验证码登录
    getCode(data) {
        return axios(baseURL + '/uims/sms/phone/code', {
            method: 'get',
            data,
        });
    },
    // 注册
    registerUser(data) {
        return axios(baseURL + '/uims/user', {
            method: 'post',
            data,
        });
    },
    // 获取用户信息
    getUserInfo() {
        return axios(baseURL + '/uims/user', {
            method: 'get',
        });
    },
    // 检查app版本
    checkVersion(data) {
        return axios(baseURL + '/app/check_update', {
            method: 'get',
            data,
        });
    },
    // 下载版本
    downloadURL(data) {
        return axios(baseURL + '/app/download_url', {
            method: 'get',
            data,
        });
    },
    // 获取视频详情信息
    getVideoDetail(data) {
        return axios(baseURL + '/video', {
            method: 'get',
            data,
        });
    },
    // 获取短片列表
    getClip(data) {
        return axios(baseURL + '/video/clips', {
            method: 'get',
            data,
        });
    },
    // 视频片段筛选项
    getClipFilters(data) {
        return axios(baseURL + '/video/clip/filters', {
            method: 'get',
            data,
        });
    },
    getTeamList(data) {
        // 获取梯队列表
        return axios(baseURL + '/teams', {
            method: 'get',
            data,
        });
    },
    getReportOverview(params) {
        // 比赛报告总揽
        return axios(baseURL + '/report/overview', {
            method: 'get',
            params,
        });
    },
    getTeachStatistics(params) {
        // 比赛报告技术
        return axios(baseURL + '/report/technical/statistics', {
            method: 'get',
            params,
        });
    },
    getDeepTechnical(params) {
        // 比赛报告深度技术
        return axios(baseURL + '/report/deep/technical', {
            method: 'get',
            params,
        });
    },
    getPlayerStatistics(params) {
        // 比赛报告球员分析
        return axios(baseURL + '/report/player/statistics', {
            method: 'get',
            params,
        });
    },
    // 梯队球员数据
    getPlayer(params) {
        return axios(baseURL + '/team/players', {
            method: 'get',
            params,
        });
    },
    // 保存短片
    saveClipVideo(data) {
        return axios(baseURL + '/video/clip', {
            method: 'post',
            data,
        });
    },
    // 更新短片
    updateClip(data) {
        return axios(baseURL + '/video/clip', {
            method: 'put',
            data,
        });
    },
    // 获取梯队球员列表
    getPlayersToTeam(params) {
        return axios(baseURL + '/report/players', {
            method: 'get',
            params,
        });
    },
    // 前锋中场后卫 个人信息
    getPlayersOtherDetail(params) { //
        return axios(baseURL + '/report/player/statistics/other', {
            method: 'get',
            params,
        });
    },
    // 守门员 个人信息
    getPlayersGFDetail(params) { //
        return axios(baseURL + '/report/player/statistics/goalKeeper', {
            method: 'get',
            params,
        });
    },
    // 矩阵表格中，根据标签获取短片
    getClopsByLabel(params) {
        return axios(baseURL + '/report/clips/detail', {
            method: 'get',
            params,
        });
    },
};
